// SPEC-CIS-REPORT-PUBLISHED-NUMBER-001 4.5: the report counter (`reportNumber`)
// is an internal key and is never rendered. Only an Issued report has a number
// a person sees: its `publishedNumber`. Everything else is named by its status.

const REF = {
  Draft: "the draft",
  Approved: "the approved report",
};

function capitalise(text) {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}

/** Positive integer or null. */
export function normalisePublishedNumber(value) {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
}

/** A report named inside a sentence: "report 2", "the draft", "the approved report". */
export function reportRef(status, publishedNumber, { capital = false } = {}) {
  const n = normalisePublishedNumber(publishedNumber);
  let text;
  if (status === "Issued") text = n ? `report ${n}` : "the issued report";
  else text = REF[status] || "the report";
  return capital ? capitalise(text) : text;
}

/** The table-row label: "Draft · 1 Sep – 7 Sep", "Report 2", "Issued · 1 Sep – 7 Sep". */
export function reportLabel(status, publishedNumber, periodText) {
  const n = normalisePublishedNumber(publishedNumber);
  if (status === "Issued" && n) return `Report ${n}`;
  const head = status === "Issued" || status === "Draft" || status === "Approved" ? status : "Report";
  return periodText ? `${head} · ${periodText}` : head;
}
